/**
 * WHICH BACKEND AM I LOOKING AT?
 *
 * A small fixed pill, shown on admin routes in every build EXCEPT the
 * production deploy context. After the production membership incident the
 * rule is that a developer must be able to tell, at a glance, whether the
 * screen in front of them can touch live customer data:
 *
 *   STAGING     green   - the expected state for previews and local work
 *   PRODUCTION  red     - a preview/local build pointing at the live project;
 *                         allowed only with a deliberate override, and loud
 *   LOCAL       grey    - a non-Supabase URL (local stack)
 *
 * The production build (Netlify CONTEXT=production) never renders this, so
 * the customer-facing site and the live admin are visually unchanged.
 */
import { SHOW_ENVIRONMENT_MARKER, DEPLOY_CONTEXT, describeBackend } from '../../lib/backendEnv';

const STYLE: Record<'PRODUCTION' | 'STAGING' | 'LOCAL', string> = {
  PRODUCTION: 'bg-red-600 text-white border-red-700',
  STAGING: 'bg-emerald-600 text-white border-emerald-700',
  LOCAL: 'bg-gray-700 text-white border-gray-800',
};

export function EnvironmentBadge() {
  if (!SHOW_ENVIRONMENT_MARKER) return null;
  const backend = describeBackend();
  const title = backend.label === 'PRODUCTION'
    ? `Diese Vorschau spricht mit der LIVE-Datenbank (${backend.ref}). Änderungen treffen echte Kunden.`
    : `Backend: ${backend.ref} (${backend.fromEnv ? 'aus Umgebungsvariablen' : 'Fallback'})`;
  return (
    <div
      role="status"
      aria-label={`Umgebung: ${backend.label}`}
      title={title}
      data-testid="environment-badge"
      data-backend={backend.label}
      className={`fixed bottom-3 left-3 z-[9999] rounded-md border px-2.5 py-1 font-mono text-[11px] font-bold tracking-wider shadow-lg pointer-events-auto select-none ${STYLE[backend.label]}`}
    >
      {backend.label}
      {backend.label === 'PRODUCTION' ? ' BACKEND' : ''}
      <span className="ml-1.5 font-normal opacity-80">{DEPLOY_CONTEXT}</span>
    </div>
  );
}

export default EnvironmentBadge;
